import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";

const reducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

// Smooth scroll that respects "reduce motion". block: "nearest" moves the page only when the
// element is (partly) out of view.
export const grScrollIntoView = (el, block = "nearest") => {
  if (!el?.scrollIntoView) return;
  el.scrollIntoView({ behavior: reducedMotion() ? "auto" : "smooth", block });
};

// Animated show / hide for a section (calendar card exercises, sets, history…).
// scrollOnOpen: once open, gently scrolls the opened part into view if it ends below the fold.
export default function GrCollapse({
  in: open,
  scrollOnOpen = false,
  unmountOnExit = true,
  children,
  ...rest
}) {
  return (
    <Collapse
      in={Boolean(open)}
      timeout={reducedMotion() ? 0 : 240}
      easing="cubic-bezier(0.2, 0, 0, 1)"
      unmountOnExit={unmountOnExit}
      onEntered={scrollOnOpen ? (node) => grScrollIntoView(node) : undefined}
      {...rest}
    >
      {children}
    </Collapse>
  );
}

GrCollapse.propTypes = {
  in: PropTypes.bool,
  scrollOnOpen: PropTypes.bool,
  unmountOnExit: PropTypes.bool,
  children: PropTypes.node,
};
